// This component checks to see if the visitor has an email address set
// If not there is a form for entering their email address
// Once the email is entered it will redirect them to the Facebook Login (`/login`)
import React, { Component, Fragment } from 'react'
import Form from '../Home/form'
import Wrapper from '../Home/wrapper'
import PropTypes from 'prop-types'
import Modal from '../../components/Modal'
import EmailInput from '../../components/EmailInput'
import { requestLeadMagnet } from '../../api'

class Home extends Component {
	state = {
		displayModal: true,
		modalEmail: null,
		emailValid: false,
		formSubmitting: false
	}

	componentDidMount() {
		if(window.mixpanel) {
			window.mixpanel.track('Landing Page Viewed', {
				name: 'AdScore'
			})
		}
	}

	handleFacebookAuthed = (session, email) => {
		this.props.facebookSessionSet(session, email)
		this.props.history.push('/accounts')
	}

	handleInputChange = (event) => {
		const email = event.target.value
		this.setState({modalEmail: email})
	}

	modalDismissed = () => {
		this.setState({displayModal: false})
	}

	submitForm = async (e) => {
		e.preventDefault()
		let { magnetId } = this.props.match.params
		this.setState({formSubmitting: true})
		await requestLeadMagnet({email: this.state.modalEmail, lead_magnet_id: magnetId})
		if(window.mixpanel) {
			window.mixpanel.track('Landing Page Converted', {
				landing_page: 'Lead Magnet Modal',
				lead_magnet_id: magnetId,
				email: this.state.modalEmail
			})
		}
		this.setState({displayModal: false})
	}

	validEmailEntered = (email) => {
		this.setState({modalEmail: email, emailValid: true})
	}

	invalidEmailEntered = (email) => {
		this.setState({modalEmail: email, emailValid: false})
	}

	renderModal() {
		return (
			<Modal display={this.state.displayModal} modalDismissed={this.modalDismissed}>
				<Fragment>
					<img src="/images/downloadIcon.png" alt="download icon" className="download" />
					<p>Download the &quot;The Insider&apos;s Guide To ROAS Bidding&quot; now!</p>
					<form onSubmit={this.submitForm}>
						<EmailInput
							focus={true}
							ref={this.emailInput}
							disabled={this.state.formSubmitting}
							validEmailEntered={this.validEmailEntered}
							invalidEmailEntered={this.invalidEmailEntered}
						/>
						{/* <input type="email" placeholder="Email Address" value={this.state.modalEmail} onChange={this.handleInputChange} /> */}
						<button
							className="cta"
							onClick={this.submitForm}
							disabled={!this.state.emailValid || this.state.formSubmitting}>
							Get Your Report
						</button>
					</form>
				</Fragment>
			</Modal>
		)
	}

	render() {
		return (
			<Wrapper>
				{this.renderModal()}
				<Form
					history={this.props.history}
					facebookSessionSet={this.handleFacebookAuthed}
					trafficSource={this.props.trafficSource}
					paidTrafficSource={this.props.paidTrafficSource}
					email={this.state.modalEmail}
					emailFocused={false} />
			</Wrapper>
		)
	}
}

Home.propTypes = {
	trafficSource: PropTypes.string,
	paidTrafficSource: PropTypes.string,
	sessionEmail: PropTypes.string,
	history: PropTypes.object,
	facebookSessionSet: PropTypes.func,
	match: PropTypes.object
}

export default Home


// WEBPACK FOOTER //
// ./src/containers/HomeLeadMagnet/index.js